function layersForSurvey(surveyId: number, layers: any[] = []): any[] {
  // For now, layer order is hard coded by type, where types earlier in the `order` array appear earlier in the output array.
  const order = ["annotation", "mapbox_vector", "mapbox_raster"];

  return layers
    .filter((layer) => layer.survey_id === surveyId)
    .sort((a, b) => {
      if (order.indexOf(a.type) < order.indexOf(b.type)) {
        return -1;
      }

      if (order.indexOf(a.type) > order.indexOf(b.type)) {
        return 1;
      }

      if (a.source_id === "ortho" && b.source_id !== "ortho") {
        return 1;
      }

      if (b.source_id === "ortho" && a.source_id !== "ortho") {
        return -1;
      }

      return b.id - a.id;
    });
}

export { layersForSurvey };
